import { Link } from 'react-router-dom';
import { categories, siteName } from '@/mocks/melons';

const guide = [
  { label: '今日热榜', href: '/#hot' },
  { label: '瓜田精选', href: '/#featured' },
  { label: '瓜田盘点', href: '/#collections' },
  { label: '常见问题', href: '/#faq' },
  { label: '关于我们', href: '/about' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-background-200 bg-background-100">
      <div className="container-page grid grid-cols-1 gap-10 py-12 md:grid-cols-12 md:py-16">
        <div className="md:col-span-4">
          <a href="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 font-heading text-lg font-black text-background-50">
              瓜
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">快手吃瓜瓜料大全</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            以瓜田盘点为主线，系统整理快手吃瓜瓜料、精品瓜与吃瓜合集，让你不必挨个刷动态，也能快速补齐必吃瓜。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
              <i className="ri-community-line" aria-hidden="true" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
              <i className="ri-chat-smile-2-line" aria-hidden="true" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
              <i className="ri-lightbulb-flash-line" aria-hidden="true" />
            </span>
          </div>
        </div>

        <div className="md:col-span-2">
          <h3 className="eyebrow text-xs font-semibold text-foreground-900">快速导航</h3>
          <ul className="mt-4 space-y-2.5">
            {guide.map((g) => (
              <li key={g.label}>
                {g.href === '/about' ? (
                  <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {g.label}
                  </Link>
                ) : (
                  <a href={g.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {g.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h3 className="eyebrow text-xs font-semibold text-foreground-900">瓜田栏目</h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {categories.map((c) => (
              <li key={c.id}>
                <a href={`/`} className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  <i className={`${c.icon} text-primary-500`} aria-hidden="true" />
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h3 className="eyebrow text-xs font-semibold text-foreground-900">站点说明</h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            本站聚焦快手吃瓜瓜田盘点与瓜料整理，仅梳理已公开的讨论信息，标注「网传待核实」内容，坚持理性吃瓜、尊重当事人。
          </p>
          <a
            href="/#faq"
            className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800"
          >
            阅读常见问题
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-page flex flex-col items-start justify-between gap-3 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© 2026 {siteName} · 内容仅供参考，理性吃瓜，尊重当事人。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-leaf-line text-primary-500" aria-hidden="true" />
            以瓜田盘点为主线，持续更新精品瓜与吃瓜合集
          </p>
        </div>
      </div>
    </footer>
  );
}